<svg #svg class="box-barcode-svg"></svg>
